<template>
  <v-layout row wrap>
    <v-flex sm12 md12 class="px-5 tabulardata">
      <v-text-field
        class="search-input"
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-flex> 
    <v-flex sm12 md12>
      <div class="text-center mb-4">
        <v-pagination :total-visible="10" :circle="true"  v-model="page" :length="pageCount"></v-pagination>
      </div>
      <v-data-table
        :headers="$store.getters.is_unoapp || $store.getters.is_corporate ? headers : headersDefault"
        :items="users"
        :search="search"
        class="px-5 pb-4 tabulardata dark-heading text-center"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        hide-default-footer
        @page-count="pageCount = $event"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.name">
            <td class="text-left">{{ item.first_name }}</td>
            <td class="text-left">{{ item.last_name }}</td>
            <td class="text-left">{{ item.email }}</td>
            <td class="text-left" v-if="$store.getters.is_superadmin || $store.getters.is_unoapp || $store.getters.is_corporate">
              <v-switch
                v-on:change="toggleUserTwofactor(item)"
                v-model="item.two_factor" 
                color="primary"
              ></v-switch>
            </td>
            <td class="text-left" v-if="$store.getters.is_superadmin || $store.getters.is_unoapp || $store.getters.is_corporate">
               <v-switch
                v-on:change="toggleUserCorporate(item)"
                v-model="item.corporate" 
                color="primary"
              ></v-switch>
            </td>
            <td class="text-left" v-if="$store.getters.is_superadmin || $store.getters.is_unoapp || $store.getters.is_corporate">
              <v-switch
                v-on:change="toggleUserStatus(item)"
                v-model="item.status_bool" 
                color="primary"
              ></v-switch>
            </td>
            <td class="text-left" v-if="$store.getters.is_superadmin || $store.getters.is_unoapp || $store.getters.is_corporate">
              <v-tooltip top  v-if="$store.getters.is_superadmin || $store.getters.is_unoapp || $store.getters.is_corporate">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="item.status === 'active'" 
                    depressed
                    @click="editRoles(item)"
                    fab 
                    dark 
                    small 
                    color="primary"
                    v-on="on"
                    :class="'mr-2'"
                  >
                    <v-icon dark>people</v-icon>
                  </v-btn>
                   <v-btn
                    v-else
                    depressed
                    @click="''"
                    fab 
                    dark 
                    small 
                    color="grey"
                    v-on="on"
                    :class="'mr-2 pointer-none'"
                  >
                    <v-icon dark>people</v-icon>
                  </v-btn>
                </template>
                <span>Edit Users Roles</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    depressed
                    v-if="($store.getters.is_superadmin || $store.getters.is_unoapp || $store.getters.is_corporate) && item.status === 'active'"
                    @click="openUserProfile(item)"
                    fab 
                    dark 
                    small 
                    color="primary"
                    v-on="on"
                    :class="'mr-2'"
                  >
                    <v-icon dark>fas fa-user-tie</v-icon>
                  </v-btn>
                  <v-btn
                    depressed
                    v-else
                    @click="''"
                    fab 
                    dark 
                    small 
                    color="grey"
                    v-on="on"
                    :class="'mr-2 pointer-none'"
                  >
                    <v-icon dark>fas fa-user-tie</v-icon>
                  </v-btn>
                </template>
                <span>User's profile</span>
              </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
        <template v-slot:no-data>
          <p class="text-xs-center mb-0">You do not have any user. You can invite user by clicking the + button</p>
        </template>
      </v-data-table>
    </v-flex> 
  </v-layout>
</template>

<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      fieldRequired: [
        v => !!v || 'Field is required',
      ],
      headers: [
        { text: 'First Name', value: 'first_name', sortable: true, class: 'font-weight-bold' },
        { text: 'Last Name', value: 'last_name', sortable: true, class: 'font-weight-bold' },
        { text: 'Email', value: 'email', sortable: false, class: 'font-weight-bold' },
        { text: 'Two factor', value: 'two_factor', sortable: false, class: 'font-weight-bold' },
        { text: 'Corporate', value: 'corporate', sortable: false, class: 'font-weight-bold' },
        { text: 'Status', value: 'status', sortable: false, class: 'font-weight-bold' },
        { text: 'Actions', value: 'roles', sortable: false, class: 'font-weight-bold text-xs-center' },
      ],
      headersDefault: [
        { text: 'First Name', value: 'first_name', sortable: true, class: 'font-weight-bold' },
        { text: 'Last Name', value: 'last_name', sortable: true, class: 'font-weight-bold' },
        { text: 'Email', value: 'email', sortable: false, class: 'font-weight-bold' },
      ],
    };
  },
  computed: {
    ...mapGetters({
      users: 'user/list',
    }),
  },
  created() {
    this.getAllUsersForBusiness();
  },
  methods: {
    /**
     * Toggle user corporate
     */

    toggleUserCorporate(user) {
      const url = `${Env.url}/api/v1/users/${user.id}/corp-access`;
      AuthApi.patchApi(url, {
        corporate: user.corporate
      })
      .then((res) => {
        this.snackbar({
          text: 'Successfully updated.',
          timeout: 4000,
          open: true,
        });
        this.getAllUsersForBusiness();
      })
      .catch((err) => {
        this.snackbar({
          text: err.response.data.msg,
          timeout: 4000,
          open: true,
        });
        this.getAllUsersForBusiness();
      });
    },
    /**
     * Toggle two factor
     */
    toggleUserTwofactor(user) {
      const url = `${Env.url}/api/v1/users/${user.id}/two-factor`;
      AuthApi.patchApi(url, {
        two_factor: user.two_factor
      })
      .then((res) => {
        this.getAllUsersForBusiness();
        this.snackbar({
          text: 'Successfully updated.',
          timeout: 4000,
          open: true,
        });
      })
      .catch((err) => {
        this.snackbar({
          text: err.response.data.msg,
          timeout: 4000,
          open: true,
        });
        this.getAllUsersForBusiness();
      });
    },

    /**
     * Toggle two factor
     */
    toggleUserStatus(user) {
       const url = `${Env.url}/api/v1/users/${user.id}/status`;
      AuthApi.patchApi(url, {
        enable: user.status_bool
      })
      .then((res) => {
        this.getAllUsersForBusiness();
        this.snackbar({
          text: res.data.msg ? res.data.msg : 'Successfully updated.',
          timeout: 4000,
          open: true,
        });
      })
      .catch((err) => {
        this.snackbar({
          text: err.response.data.msg,
          timeout: 4000,
          open: true,
        });
        this.getAllUsersForBusiness();
      });
    },
    
    /**
     * Get all users for business
     */
    getAllUsersForBusiness() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}/users`;
      AuthApi.getApi(url)
      .then((res) => {
        let rawdata = res.data.payload;
        rawdata.map(item => {
          if(item.status == 'active') {
            item.status_bool = true;
          } else {
            item.status_bool = false;
          }
        })
        this.userlist(rawdata);
      })
      .catch((err) => {
        console.log(err.response.data.msg);
      });
    },
  
    /**
     * Open add new user popup
     */
    addLocation() {
      this.userEditLocationObj(obj);
      this.userEditLocation(true);
    },
    
    /**
     * View user details
     */
    editRoles(obj) {
      this.userEditRoleObj(obj);
      this.userEditRole(true);
    },

    /**
     * Delete item
     */
    deleteItem(obj) {
      this.setUserDeleteObj(obj);
      this.setUserDeletePopup(true);
    },

    /**
     * User profile
     */

    openUserProfile(obj) {

      this.setUserProfile(true);
      this.setUserProfileObj(obj);
    },

    ...mapActions({
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
      userlist: 'user/setList',

      setUserProfile: 'user/setUserProfile',
      setUserProfileObj: 'user/setUserProfileObj',
  
      userEditRole: 'user/setEditRole',
      userEditRoleObj: 'user/setEditRoleObj',
    
      setUserDeleteObj: 'user/setDeleteObj',
      setUserDeletePopup: 'user/setDelete',
    }),
  },
};
</script>
